import React from 'react';
import TitoloPagine from '../TitoloPagine';

function OrderResume(props) {
    const subtotal= props.subtotal
    const tax_total= props.tax_total
    const selectedShippingCost = props.selectedShippingCost

    return (
        <div className="order-resume col-12">
            <div>
                <TitoloPagine title={"RIEPILOGO"}></TitoloPagine>  
            </div>
            <table style={{textAlign:"left", width:"100%"}}>
                <thead>
                    <tr>
                        <th style={{width:"50%"}}></th>
                        <th style={{width:"50%"}}></th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="">
                        <td><b>Subtotal:</b></td>
                        <td style={{textAlign:"right"}}>{Number(subtotal).toFixed(2)} €</td>
                    </tr>
                    <tr className="">
                        <td><small><b>Tax(included):</b></small></td>
                        <td style={{textAlign:"right"}}><small>{Number(tax_total).toFixed(2)} €</small></td>
                    </tr>
                    {selectedShippingCost ? 
                    <>
                            <tr className="">
                            <td><b>Shipping:</b></td>
                            <td style={{textAlign:"right"}}>{Number(selectedShippingCost.shipping_price).toFixed(2)} €</td>
                        </tr>
                        {selectedShippingCost.insurance_price > 0 ? 
                        <tr className="">
                            <td><b>Insurance:</b></td>
                            <td style={{textAlign:"right"}}>{Number(selectedShippingCost.insurance_price).toFixed(2)} €</td>
                        </tr>
                        :null}
                        <tr style={{fontSize:"20px"}} className="">
                            <td><b>Total:</b></td>
                            <td style={{textAlign:"right"}}> {(Number(subtotal) + Number(selectedShippingCost.shipping_price) + Number(selectedShippingCost.insurance_price)).toFixed(2)} €</td>
                        </tr>
                    </>
                    : null }
                </tbody>
            </table>
            {props.checkout ? 
                <div style={{textAlign:"center",marginTop:"15px"}}>
                    <button className={"button-resume"} onClick={()=>{props.checkout()}}>ACQUISTA ></button>
                </div>
            :null}
        </div>
    );
}

export default OrderResume;